// ../helpers/userFunctions/checkUserStatus.js

export const checkUserStatus = async (
  email,
  fin = null,
  kmStand = null,
  api,
  isManual = false // ← neuer Parameter
) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  // 1) E-Mail validieren
  if (!email || !emailRegex.test(email)) {
    alert("Bitte geben Sie eine gültige E-Mail-Adresse ein.");
    return;
  }

  try {
    const response = await fetch(`${api}/login/checkUser`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email,
        fin,
        kmStand,
        isManual, // ← jetzt mit übergeben
      }),
    });

    if (response.ok) {
      const data = await response.json();
      console.log("[checkUserStatus] Server-Antwort:", data.status);

      switch (data.status) {
        case "manualUserExists":
          return "manualUserExists";

        case "manualUserNotFound":
          return "manualUserNotFound";

        case "existingUser":
          return "existingUser";

        case "finAvailable":
          return "signUpWithFin";

        case "noAccount":
          return "noAccountFound";

        default:
          console.error("Unbekannter Status:", data.status);
          return "";
      }
    } else {
      const errorData = await response.json();
      console.error(
        "Fehler von Server:",
        errorData.error || "Unbekannter Fehler"
      );
      return null;
    }
  } catch (error) {
    console.error("Error fetching data for email:", email, error);
    return null;
  }
};
